<template>
  <div class="box">
    <Tabs value="name1">
      <TabPane label="按日选择" name="name1">
        <div style="display: flex; width: 100%; justify-content: space-between">
          <DatePicker
            :value="time"
            format="yyyy/MM/dd"
            placement="bottom-start"
            type="daterange"
            placeholder="开始时间 - 结束时间"
            style="width: 300px; margin-bottom: 20px"
            @on-change="getTime"
          ></DatePicker>
          <p style="margin-right: 30px; margin-top: 10px">
            <Button type="primary" style="margin: 0px 20px" @click="exportExcel"
              >导出</Button
            >
          </p>
        </div>
        <Table ref="table" stripe :columns="columns1" :data="dataDay"></Table
      ></TabPane>
      <TabPane label="按月选择" name="name2">
        <div style="display: flex; width: 100%; justify-content: space-between">
         <div>
          <DatePicker
            :value="monthValue"
            format="yyyy-MM"
            placement="bottom-start"
            type="month"
            style="margin-bottom: 20px" 
            placeholder="请选择开始月份"
            @on-change="getStartMonth"
          ></DatePicker>
          <DatePicker
            :value="monthendValue"
            format="yyyy-MM"
            placement="bottom-start"
            type="month"
            style="margin-bottom: 20px" 
            placeholder="请选择结束月份"
            @on-change="getEndMonth"
          ></DatePicker>
         </div>
          <Button type="primary" style="margin: 0px 20px" @click="exportMonth"
            >导出</Button
          >
        </div>
        <Table
          stripe
          ref="tablemonth"
          :columns="columns2"
          :data="dataMonth"
        ></Table>
      </TabPane>
    </Tabs>
    <Modal
      v-model="modal"
      title="日期统计"
      @on-ok="ok"
      @on-cancel="cancel"
      width="1200px"
    >
      <Table stripe :columns="columns1" :data="modalDay"></Table>
    </Modal>
  </div>
</template>
<script>
import { GetNovelReport } from "@/api/api"; //接口测试
export default {
  data() {
    return {
      dataDay: [],
      dataMonth: [],
      modalDay: [], //弹窗数据
      modal: false,
      monthValue: "",
      monthendValue:'',
      mValue: "",
      columns1: [
        {
          title: "日期",
          key: "reportDate",
        },
        {
          title: "书籍名称",
          key: "bookName",
        },
        {
          title: "版权方书籍ID",
          key: "thirdBookId",
        },
        {
          title: "作者",
          key: "bookAuthor",
        },
        {
          title: "销售金额",
          key: "rechargeAmount",
        },
        {
          title: "分成金额",
          key: "shareAmount",
        },
      ],
      columns2: [
        {
          title: "月份",
          key: "reportDate",
        },
        {
          title: "书籍名称",
          key: "bookName",
        },
        {
          title: "版权方书籍ID",
          key: "thirdBookId",
        },
        {
          title: "作者",
          key: "bookAuthor",
        },
        {
          title: "销售金额",
          key: "rechargeAmount",
        },
        {
          title: "分成金额",
          key: "shareAmount",
        },
        {
          title: "操作",
          render: (h, params) => {
            return h("div", [
              h(
                "span",
                {
                  style: {
                    color: "#409eff",
                    marginRight: "5px",
                    cursor: "pointer",
                  },
                  on: {
                    click: () => {
                      this.checkView(params.row);
                    },
                  },
                },
                "查看"
              ),
            ]);
          },
        },
      ],
      startTimeBegin: "",
      enTimeBegin: "",
      time: [],
    };
  },
  mounted() {
    this.startTimeBegin = this.getDay(-31);
    this.enTimeBegin = this.getDay(-1);
    this.time = [this.startTimeBegin, this.enTimeBegin];
    this.GetNovelReport();
    this.monthValue = this.getMonths(0);
    this.monthendValue = this.getMonths(0);
    this.GetNovelReportMonth();
  },
  methods: {
    exportExcel() {
      this.$refs.table.exportCsv({
        filename: "小说统计",
         data: this.dataDay.map(item =>{
                    item.reportDate = ' '+item.reportDate+' '
                    return item;
                })
       
      });
    },
    exportMonth() {
      this.$refs.tablemonth.exportCsv({
        filename: "小说按月统计",
         data: this.dataMonth.map(item =>{
                    item.reportDate = ' '+item.reportDate+' '
                    return item;
                })
      });
    },
    getStartMonth(value) {
      console.log(value)
      this.monthValue = value;
      this.GetNovelReportMonth();
    },
    getEndMonth(value) {
      console.log(value)
      this.monthendValue = value;
      this.GetNovelReportMonth();
    },
    getTime(value) {
      this.startTimeBegin = value[0];
      this.enTimeBegin = value[1];
      this.GetNovelReport();
    },
    getMonths(day) {
      var today = new Date();
      var targetday_milliseconds = today.getTime() + 1000 * 60 * 60 * 24 * day;
      today.setTime(targetday_milliseconds); //注意，这行是关键代码
      var tYear = today.getFullYear();
      var tMonth = today.getMonth();
      var tDate = today.getDate();
      tMonth = this.doHandleMonth(tMonth + 1);
      tDate = this.doHandleMonth(tDate);

      return tYear + "-" + tMonth;
    },
    getDay(day) {
      var today = new Date();
      var targetday_milliseconds = today.getTime() + 1000 * 60 * 60 * 24 * day;
      today.setTime(targetday_milliseconds); //注意，这行是关键代码
      var tYear = today.getFullYear();

      var tMonth = today.getMonth();

      var tDate = today.getDate();

      tMonth = this.doHandleMonth(tMonth + 1);

      tDate = this.doHandleMonth(tDate);

      return tYear + "-" + tMonth + "-" + tDate;
    },
    doHandleMonth(month) {
      var m = month;
      if (month.toString().length == 1) {
        m = "0" + month;
      }
      return m;
    },
    checkView(row) {
      var year = row.reportDate.split("-")[0];
      var month = row.reportDate.split("-")[1];
      var d = new Date(year, month, 0);
      var startTime = row.reportDate + "-01";
      var endTime = row.reportDate + "-" + d.getDate();
      this.getDatas(endTime, startTime, row.thirdBookId,row.bookId);
    },
    getDatas(endTime, startTime, thirdBookId,bookId) {
      var params = {
        endTime: endTime,
        startTime: startTime,
        month: "",
        thirdBookId: thirdBookId,
        bookId:bookId
      };
      GetNovelReport(params).then((res) => {
        if (res.code == 200 && res.data != null) {
          this.modal = true;
          this.modalDay = res.data;
        } else {
          this.modalDay = [];
        }
      });
    },
    GetNovelReport() {
      var params = {
        endTime: this.enTimeBegin,
        startTime: this.startTimeBegin,
        month: "",
      };
      GetNovelReport(params).then((res) => {
        if (res.code == 200) {
          this.dataDay = res.data;
        }
      });
    },
    GetNovelReportMonth() {
      var params = {
        endTime: "",
        startTime: "",
        startMonth: this.monthValue,
        endMonth: this.monthendValue,
      };
      console.log(params)
      GetNovelReport(params).then((res) => {
        if (res.code == 200) {
          this.dataMonth = res.data;
        }
      });
    },
    cancel() {},
    ok() {},
  },
};
</script>
<style lang="less" scoped>
.box {
  padding: 50px;
  min-height: 1000px;
  .ivu-tabs {
    min-height: 800px;
  }
  > h1 {
    margin-bottom: 20px;
  }
}
</style>


// WEBPACK FOOTER //
// src/view/FictionStatistics/Fictionstatistics.vue